import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Timeline from 'components/base/Timeline';
import { Col, Row } from 'react-bootstrap';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { fetchRiskAlerts, HVARiskCallValue } from 'services/hvarisk.service';

const RiskTimeline: React.FC = () => {
  const [risks, setRisks] = useState<HVARiskCallValue[]>([]);

  const fetchData = async () => {
    try {
      const criticalRisks = await fetchRiskAlerts({
        limit: 100
      });

      // Los datos ya vienen ordenados del backend
      setRisks(criticalRisks);
    } catch (error) {
      console.error('Error fetching risk timeline data:', error);
      setRisks([]);
    }
  };

  useEffect(() => {
    fetchData();

    const interval = setInterval(() => {
      fetchData();
    }, 30000); // Actualizar cada 30 segundos

    return () => clearInterval(interval);
  }, []);

  const formatTimeAgo = (dateString: string) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 60) return `${diffMins}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    return `${diffDays}d ago`;
  };

  return (
    <div
      className="scrollbar pe-2"
      style={{ maxHeight: '415px', height: '415px' }}
    >
      <Timeline variant="vertical">
        {risks.map((risk, index) => (
          <Timeline.Item className="position-relative" key={risk.id}>
            <Row className="g-md-3 pb-2">
              <Col xs="auto" md="auto" className="d-flex pe-0">
                <Timeline.OppositeContent>
                  <p className="fs-10 fw-semibold text-body-tertiary text-opacity-85 text-end mb-0">
                    {new Date(risk.iariskvaluedate).toLocaleDateString()}
                    <br className="d-none d-md-block" />
                    <span className="fs-10">
                      {formatTimeAgo(risk.iariskvaluedate)}
                    </span>
                  </p>
                </Timeline.OppositeContent>
                <Timeline.Separator className="position-md-relative me-2">
                  <Timeline.Dot className="bg-body-emphasis">
                    <FontAwesomeIcon
                      icon={faExclamationTriangle}
                      className="text-primary-dark fs-9"
                    />
                  </Timeline.Dot>
                  {index !== risks.length - 1 && (
                    <Timeline.Bar className="h-100 border-dashed" />
                  )}
                </Timeline.Separator>
              </Col>
              <Col className="px-0">
                <Timeline.Content className="px-0">
                  <h5 className="fs-9 mb-0">
                    {risk.hvariskelement?.name || 'Risk Detected'}
                  </h5>
                  <p className="fs-10 mb-0">
                    Call ID:{' '}
                    <span className="fs-9 text-primary-dark">
                      {risk.callid}
                    </span>
                  </p>
                  <p className="fs-10 text-body-secondary lh-sm mb-1">
                    {risk.hvariskelement?.hvariskcategory?.name ||
                      'Uncategorized'}
                    <br />
                    Severity:{' '}
                    <span className="fw-bold">{risk.iariskvalue}</span>
                  </p>
                </Timeline.Content>
              </Col>
            </Row>
          </Timeline.Item>
        ))}
      </Timeline>
    </div>
  );
};

export default RiskTimeline;
